/***************************************************************************************
 * FileName      : TitleOverlay.tsx
 * Description   : 시스템 타이틀 오버레이 (실험실 둘러보기 CTA)
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.09
 * Modified Date : 2026.02.25
 * Reference     : mockup/index.html (Phase 2: 타이틀 오버레이)
 ***************************************************************************************/

/// <reference path="../global.d.ts" />
import React from 'react';

interface Props {
  isVisible: boolean;
  onExplore: () => void;
}

// 2026.02.09 : 박은정 : 목업 Phase 2 타이틀 오버레이 컴포넌트 추가
export const TitleOverlay: React.FC<Props> = ({ isVisible, onExplore }) => {
  if (!isVisible) return null;

  return (
    <div className="title-overlay title-overlay--visible">
      {/* 반투명 배경 */}
      <div className="title-overlay__backdrop" />

      {/* 중앙 카드 */}
      <div className="title-overlay__card">
        {/* 시스템 로고 */}
        <div className="title-overlay__logo">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
          </svg>
        </div>

        {/* 시스템명 */}
        <h1 className="title-overlay__title">디지털트윈 기반 화학 공정 실습 교육 시스템</h1>
        <p className="title-overlay__subtitle">Digital Twin Process Training System</p>

        {/* 구분선 */}
        <div className="title-overlay__divider" />

        {/* 설명 */}
        <p className="title-overlay__description">
          화공 실험장비의 구조와 운전을<br />
          3D 환경에서 학습하는 온라인 시뮬레이션 교육
        </p>

        {/* CTA 버튼 */}
        <button className="title-overlay__cta-btn" onClick={onExplore}>
          실험실 둘러보기
        </button>

        {/* 2026.02.13 : 박은정 : 모달 하단 버전 표시 (webpack DefinePlugin 주입, 미주입 시 폴백) */}
        <p className="title-overlay__version">v{typeof APP_VERSION !== 'undefined' ? APP_VERSION : '1.0.1'}</p>
      </div>

      {/* 하단 정보 */}
      <div className="title-overlay__footer">
        <div className="title-overlay__footer-logos">
          <span className="title-overlay__footer-logo-item">순천제일대학교</span>
          {/* 2026.02.25 : 박은정 : 하단 기관명 클릭 시 Matterport 3D Showcase 링크 연결 */}
          <a
            className="title-overlay__footer-logo-item title-overlay__footer-logo-link"
            href="https://my.matterport.com/show/?m=U4AxQrk4Wfj"
            target="_blank"
            rel="noopener noreferrer"
          >
            (주)한국공학기술연구원
          </a>
        </div>
      </div>
    </div>
  );
};

